import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const services = [{
  title: 'Light Dom Sessions',
  description: 'An accessible entry into power exchange — guided, attentive, and tailored to those new to the dynamic.',
  rate: 'From $350'
}, {
  title: 'Pegging Sessions',
  description: 'Confident, skilled, and considered. A refined experience grounded in trust, communication, and pacing.',
  rate: '$200'
}, {
  title: 'Discipline & Training',
  description: 'Structured sessions focused on obedience, protocol, and behavioral modification.',
  rate: 'From $350'
}, {
  title: 'Bondage & Restraint',
  description: 'Artistic and functional rope work, restraint techniques, and immobilization.',
  rate: 'From $350'
}, {
  title: 'Psychological Dominance',
  description: 'Mind-focused sessions exploring control, surrender, and mental submission.',
  rate: 'From $350'
}, {
  title: 'Sensory Exploration',
  description: 'Guided experiences in sensation play, deprivation, and heightened awareness.',
  rate: 'From $350'
}, {
  title: 'Fetish Showers — Golden',
  description: 'A discreet, hygienic ritual for the devoted. Performed with composure and intention.',
  rate: '$250'
}, {
  title: 'Fetish Showers — Brown',
  description: 'An advanced devotional experience. Reserved for thoroughly screened, sincere applicants.',
  rate: '$450'
}, {
  title: 'Toilet Training',
  description: 'Specialized training for those seeking this particular form of service and submission.',
  rate: 'Inquire'
}, {
  title: 'Impact Play',
  description: 'Skillful application of various implements with attention to safety and intensity.',
  rate: 'From $350'
}, {
  title: 'Role Play Scenarios',
  description: 'Immersive experiences tailored to your fantasies and psychological needs.',
  rate: 'From $350'
}, {
  title: 'Lifestyle Mentorship',
  description: 'Ongoing guidance for those integrating BDSM into their daily lives.',
  rate: 'Inquire'
}];
export function Services() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="experiences" ref={ref} className="py-24 lg:py-32 bg-onyx" data-id="element-278">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-279">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-280">
          <p className="text-gold text-xs uppercase tracking-[0.3em] mb-4 font-cinzel" data-id="element-281">
            Services & Experiences
          </p>
          <h2 className="font-cormorant text-bone text-4xl lg:text-6xl font-light mb-6" data-id="element-282">
            Curated Experiences
          </h2>
          <p className="text-silver-muted text-lg max-w-2xl mx-auto" data-id="element-283">
            Pegging sessions begin at $200. Light Dom and standard experiences
            from $350. Each session is tailored to your desires, boundaries, and
            journey.
          </p>
        </motion.div>

        {/* Editorial split banner */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 1,
        delay: 0.2
      }} className="grid md:grid-cols-2 gap-0 mb-16 border border-gold/15" data-id="element-284">
          {/* Portrait — keeps head/top of frame visible at all sizes */}
          <div className="relative aspect-[4/5] overflow-hidden" data-id="element-285">
            <img src="https://cdn.magicpatterns.com/uploads/dPot6R3X5y6d5iGavzUDii/13.jpg" alt="Madam Yas" className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-286" />
          </div>
          {/* Quote panel */}
          <div className="bg-ink p-8 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-287">
            <p className="text-gold font-cinzel text-xs tracking-[0.4em] mb-4" data-id="element-288">
              THE PRACTICE
            </p>
            <p className="font-cormorant text-bone text-2xl md:text-3xl lg:text-4xl font-light italic leading-snug mb-6" data-id="element-289">
              "Power, properly held, is a form of generosity."
            </p>
            <p className="text-silver-muted text-sm leading-relaxed" data-id="element-290">
              Each session is approached as a craft — the result of training,
              attention, and an unwavering respect for the person across from
              me.
            </p>
            <div className="mt-8 pt-6 border-t border-gold/20" data-id="element-291">
              <p className="text-gold font-cinzel text-xs tracking-[0.3em]" data-id="element-292">
                — MADAM YAS
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-293">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.08
        }} className="bg-ink border border-gold/10 p-6 hover:border-gold/40 transition-all duration-300 group flex flex-col" data-id="element-294">
              <h3 className="font-cormorant text-bone text-xl mb-3 group-hover:text-gold transition-colors" data-id="element-295">
                {service.title}
              </h3>
              <p className="text-silver-muted text-sm leading-relaxed flex-1" data-id="element-296">
                {service.description}
              </p>
              <div className="mt-5 pt-4 border-t border-gold/15" data-id="element-297">
                <p className="text-gold text-xs uppercase tracking-[0.25em] font-cinzel" data-id="element-298">
                  {service.rate}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center mt-12" data-id="element-299">
          <p className="text-silver-muted text-xs uppercase tracking-[0.25em] mb-6" data-id="element-300">
            Extended sessions, travel, and other arrangements available upon
            inquiry
          </p>
          <a href="#contact" className="inline-block px-8 py-4 border border-gold text-gold text-sm uppercase tracking-widest hover:bg-gold hover:text-ink transition-all duration-300" data-id="element-301">
            Schedule a Private Session
          </a>
        </motion.div>
      </div>
    </section>;
}